import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorProductPriceListCustomer = () => {
  const priceListCustomer = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/product/price-list/customer', payload, (response) => {
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
      loading(false)
    })
  }, [])

  return { priceListCustomer }
}

export default InteractorProductPriceListCustomer
